import { render } from "./policy-quote.vue?vue&type=template&id=6d1bdef4&scoped=true"
import script from "./policy-quote.vue?vue&type=script&lang=js"
export * from "./policy-quote.vue?vue&type=script&lang=js"

import "./policy-quote.vue?vue&type=style&index=0&id=6d1bdef4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1bdef4"]])

export default __exports__